var wrapper = require('./wrapper');

module.exports = function (name, obj) {
  var f = { value : obj, constant : true };
  this.$$factories[name] = f;
  return wrapper(f).lifecycle.application();
};



//////////////////
// WEBPACK FOOTER
// ./~/jpex/src/factories/constant.js
// module id = 562
// module chunks = 40